import { gql } from 'graphql-tag'

export const UPSERT_ADDRESS_IMAGE = gql`
  mutation upsertAddressImage(
    $addressId: ID!
    $addressImageInput: UpsertAddressImageInput!
    $imageType: AddressImageType!
  ) {
    upsertAddressImage(addressId: $addressId, addressImageInput: $addressImageInput, imageType: $imageType) {
      addressId
      imageType
      createdAt
      key
      updatedAt
      meta
      tags
    }
  }
`
